import React from "react";
import * as ReactDOM from "react-dom";
import { Bootstrap } from "./app";
import "./styles/global.scss";
import { initAnalytics } from "./analytics/init";
initAnalytics();
document.addEventListener("DOMContentLoaded", function () {
    // ReactDOM.render(<Preview />, document.querySelector("#app"));
    ReactDOM.render(React.createElement(Bootstrap, null), document.querySelector("#app"));
});
